import {AppCtx} from "../../ioc/ApplicationContext";
import {HttpService, HTTP_SERVICE_NAME} from "../http/HttpService";
import {injectable} from "inversify";
import {Operator, ListOperatorsResponse}from "../../../generated/protocol";
import {AbstractAdminEntityService} from "./AbstractAdminEntityService";

export const OPERATOR_SERVICE_NAME = "operatorService";

@injectable()
export class OperatorService extends AbstractAdminEntityService<Operator, ListOperatorsResponse> {

    http: HttpService;

    constructor() {
        super("/operator");
        this.http = AppCtx.resolve<HttpService>(HTTP_SERVICE_NAME);
    }

    getCurrencies(): Promise<string[]> {
        return this.http.doGet(this.entityPath + "/currencies")
    }
}



// WEBPACK FOOTER //
// ./src/app/service/admin/OperatorService.ts